<ngx-spinner bdColor="rgba(0,0,0,0.4)" size="large" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
</ngx-spinner>

<div>
  <header class="header">
    <img src="assets/images/gsklogonew.png" alt="Footer Image" style="width: 10%; height: 100%;">
    <img src="assets/images/Orenge-Logo.png" alt="Footer Image" style="width: 15%; height: 100%;">
  </header>
</div>
<div style="display: flex; justify-content: center; align-items: center; width: 100%;">
  <div
    style="display: flex; justify-content: center; align-items: center; width: 100%; background-color: rgb(255, 123, 0); height: 5px;">
  </div>
</div>
<div
  style="background-image: url('assets/images/bg3.jpg');background-size: cover; background-position: center;background-repeat: no-repeat;">
  <div class="container1">
    <div class="image-box">
      <img src="assets/images/bg1.png" alt="Image" class="background-image">
    </div>
    <div class="info-box1">
      <div class="info-box">
        <div class="formContent">
          <div class="card px-5 pt-4 d-flex justify-content-center logincontainerheader">
            <div class="loginheader">
              <div style="font-size: 21px;">
                One step closer to VaxiKart
              </div>
              <div style="font-size: 21px;">
                exclusive benefits
              </div>
            </div>
            <!-- <div class="KYC">KYC Portal</div> -->
            <div style="display: flex;justify-content: center;margin-top: 10px;">
              <div class="signinBoard">Sign in</div>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 20px;">
              <form [formGroup]="FG_Login" style="width: 100%;">
                <div>
                  <!-- Radio buttons for Login Type -->
                  <div class="form-group">
                    <label class="radio-box">
                      <input type="radio" formControlName="loginType" value="HCP" (change)="onLoginTypeChange('HCP')" />
                      <span>Login as HCP</span>
                    </label>
                    <label class="radio-box">
                      <input type="radio" formControlName="loginType" value="Rep" (change)="onLoginTypeChange('Rep')" />
                      <span>Login as Rep</span>
                    </label>
                  </div>
                  <!-- Conditional Mobile Number Input for 'Login as HCP' -->
                  <div *ngIf="selectedLoginType === 'HCP'"
                    style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
                    <input type="text" formControlName="MobileNo" class="form-control mobileinput" id="MobileNo"
                      maxlength="10" placeholder="MOBILE NUMBER"
                      style="text-align: center;padding: 10px;font-size: 20px;width: 80%;" />
                    <div *ngIf="submitted && f['MobileNo'].errors" style="width: 80%;">
                      <div *ngIf="f['MobileNo'].errors['required']" class="error_msgcustom">Mobile Number is required
                      </div>
                      <div *ngIf="f['MobileNo'].errors['pattern']" class="error_msgcustom">Mobile number must be 10
                        digits.</div>
                    </div>
                    <span class="md-line"></span>
                  </div>

                  <!-- Conditional Email Input for 'Login as Rep' -->
                  <div *ngIf="selectedLoginType === 'Rep'"
                    style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
                    <input type="email" formControlName="Email" class="form-control" id="Email"
                      placeholder="GSK Email id" style="text-align: center;padding: 10px;font-size: 20px;width: 80%;" />
                    <div *ngIf="submitted && f['Email'].errors" style="width: 80%;">
                      <div *ngIf="f['Email'].errors['required']" class="error_msgcustom">Email is required</div>
                      <div *ngIf="f['Email'].errors['pattern']" class="error_msgcustom">Email must contain {{gsk}}</div>
                    </div>
                    <span class="md-line"></span>
                  </div>

                  <!-- OTP Section (remains unchanged) -->
                  <div class="row-margin-10" *ngIf="IsOtpVisibleFp"
                    style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
                    <input type="text" formControlName="OTP" class="form-control otpinput" id="OTP"
                      [placeholder]="placeholder" maxlength="6"
                      style="text-align: center;padding: 15px;font-size: 20px;width: 80%;" />
                    <div *ngIf="submitted && f['OTP'].errors && selectedLoginType === 'HCP'" style="width: 80%;">
                      <div *ngIf="f['OTP'].errors['required']" class="error_msgcustom">Mobile OTP is required</div>
                      <div *ngIf="f['OTP'].errors['pattern']" class="error_msgcustom">Mobile OTP must be 6 digits.</div>
                    </div>
                    <div *ngIf="submitted && f['OTP'].errors && selectedLoginType === 'Rep'" style="width: 80%;">
                      <div *ngIf="f['OTP'].errors['required']" class="error_msgcustom">Email OTP is required</div>
                      <div *ngIf="f['OTP'].errors['pattern']" class="error_msgcustom">Email OTP must be 6 digits.</div>
                    </div>
                    <span class="md-line"></span>
                  </div>
                  <div class="col-md-12" *ngIf="IsOtpVisibleFp">
                    <span class="font-weight-bold text-danger" *ngIf="this.showTimeFp!=otpExpired">
                      Remaining time &nbsp;{{showTimeFp}}</span>
                    <label *ngIf="this.showTimeFp==otpExpired">{{this.otpExpired}}</label>
                  </div>
                  <div style="margin-top: 15%;margin-bottom: 10%;"
                    *ngIf="!IsOtpVisibleFp && selectedLoginType === 'HCP'">
                    <label class="lbl">Enter Mobile Number here and Click send OTP</label>
                  </div>
                  <div style="margin-top: 15%;margin-bottom: 10%;"
                    *ngIf="!IsOtpVisibleFp && selectedLoginType === 'Rep'">
                    <label class="lbl">Enter GSK Email id here and Click send OTP</label>
                  </div>
                  <!-- Other Button Actions -->
                  <div class="row-margin-10" *ngIf="!IsOtpVisibleFp">
                    <div class="col-md-12">
                      <div class="centeralign">
                        <button type="button" (click)="SendOTP()"
                          class="btn btn-primary btn-md btn-block waves-effect">Send OTP</button>
                      </div>
                    </div>
                  </div>

                  <!-- Verify Button -->
                  <div class="row-margin-10" *ngIf="IsbtnVerifyUserVisibleFp">
                    <div class="col-md-12">
                      <div class="centeralign">
                        <button type="button" (click)="KYCVerifyOTP()"
                          class="btn btn-primary btn-md btn-block waves-effect">Verify</button>
                      </div>
                    </div>
                  </div>

                  <!-- Resend OTP -->
                  <div class="text-center" *ngIf="IsBtnResendVisibleFp">
                    <span class="d-block mobile-text">
                      Don't receive the code? <a class="cursorpointer" (click)="ResendOTP()">Resend</a>
                    </span>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%;">
    <div
      style="display: flex; justify-content: center; align-items: center; width: 80%; background-color: rgb(255, 123, 0); height: 5px;">
    </div>
  </div>
  <div class="bg2-container">
    <img src="assets/images/bg2.png" alt="Footer Image" style="width: 100%; height: 100%;">
  </div>
</div>
<div style="background-color: white;padding-bottom: 2%;">
  <div class="footer1">
    <div class="image-container">
      <div class="image-item" *ngFor="let image of images">
        <a [href]="image.url" target="_blank">
          <img [src]="image.src" [alt]="image.alt" />
        </a>
        <div class="vertical-line"></div>
      </div>
    </div>
    <div class="footer-content">
      <b>Reference: 1.</b> CDC - Travelers' Health: Routine Vaccines. Accessed from:
      https://wwwnc.cdc.gov/travel/page/routine-vaccines. Accessed on: May 2024. **Click the button to avail either a
      complete traveler bundle (10 Fluarix Tetra, 5 Menveo, 5 Boostrix, 5 Varilrix, 5 Priorix) or a compact traveler
      bundle (10 Fluarix Tetra, 5 Menveo, 5 Boostrix). Orders available without offers as well. Standard T&C's of
      vaxikart apply. Trademarks are owned by & licensed to the GSK group of companies. The information contained in
      this material is strictly privileged and confidential and is for the use of Registered Medical Practitioners duly
      licensed under the laws of India. Please report any adverse events with any GSK product to the company at
      india.pharmacovigilence{{gsk}}. For more information, contact: GlaxoSmithKline Pharmaceuticals Ltd., Dr. Annie
      Besant Road, Worli, Mumbai 400 030, India.
      PM-IN-ABX-WCNT-240002. DOP: October 2024
    </div>
  </div>
</div>